import React from "react"
import styled from "styled-components"
import {NextLink} from "~/components/Link"

const Container = styled.div`
  display: block;
  color: ${props => props.theme.colors.text.label};
`
const Seperate = styled.span`
  margin: 0 0.6em 0 0.6em;
`

const Breadcrumbs = ({ levels }) => {
  return (
    <Container>
      {levels.map((level, ind) => {
        const isLast = (ind +1) === levels.length
      return (
        <React.Fragment key={level.title}>
          {isLast ? (
            <span>{level.title}</span>
          ): (
            <>
              <NextLink href={level.href} as={level.as} passHref>
                {level.title}
              </NextLink>
              <Seperate> / </Seperate>
            </>
          )}
        </React.Fragment>
)
    })}
    </Container>
  )
}

export default Breadcrumbs
